import React from 'react';
import { Link } from 'react-router-dom';

const PHONE_NUMBER = process.env.REACT_APP_PHONE_NUMBER || '+27210000000';
const PHONE_DISPLAY = PHONE_NUMBER.replace(/(\+27)(\d{2})(\d{3})(\d{4})/, '$1 $2 $3 $4');
const AFTER_HOURS = process.env.REACT_APP_AFTER_HOURS_NUMBER || '+27820000000';
const AFTER_HOURS_DISPLAY = AFTER_HOURS.replace(/(\+27)(\d{2})(\d{3})(\d{4})/, '$1 $2 $3 $4');

export function PublicFooter() {
  return (
    <footer
      className="text-white relative overflow-hidden"
      style={{ backgroundColor: 'var(--color-navy)' }}
    >
      {/* Large low-opacity logo watermark */}
      <img
        src="/images/logo-symbol-only.png"
        alt=""
        aria-hidden="true"
        className="absolute pointer-events-none select-none"
        style={{ width: 220, right: 16, top: '50%', transform: 'translateY(-50%)', opacity: 0.07 }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* Column 1 — Practice */}
          <div>
            <img src="/images/logo-colour.png" alt="IKhanGynae" className="h-12 mb-4" />
            <p
              className="font-heading text-xl mb-1"
              style={{ fontFamily: 'var(--font-heading)', color: 'var(--color-gold)' }}
            >
              IKhanGynae
            </p>
            <p className="text-white/70 text-sm mb-1">Dr Imraan Khan FCOG(SA)</p>
            <p className="text-white/70 text-sm mb-1">JKD at Melomed Gatesville &amp; Melomed Mitchell's Plain</p>
            <p className="text-white/70 text-sm mb-1">Cape Town, Western Cape</p>
            <p className="text-white/70 text-sm mt-3">
              <a href={`tel:${PHONE_NUMBER}`} className="hover:text-gold transition-colors" style={{ color: 'var(--color-gold)' }}>
                {PHONE_DISPLAY}
              </a>
            </p>
            <p className="text-white/70 text-xs">
              Gatesville: <a href="tel:0216371343" className="hover:text-gold transition-colors" style={{ color: 'var(--color-gold)' }}>021 637 1343</a>
            </p>
            <p className="text-white/70 text-xs">
              Mitchell's Plain: <a href="tel:0213928141" className="hover:text-gold transition-colors" style={{ color: 'var(--color-gold)' }}>021 392 8141</a>
            </p>
            <p className="text-white/70 text-sm">
              <a href="mailto:drikhan@ikhangynae.co.za" className="hover:text-gold transition-colors">
                drikhan@ikhangynae.co.za
              </a>
            </p>
          </div>

          {/* Column 2 — Quick Links */}
          <div>
            <h3
              className="font-heading text-lg mb-4"
              style={{ fontFamily: 'var(--font-heading)', color: 'var(--color-gold)' }}
            >
              Quick Links
            </h3>
            <ul className="space-y-2 text-white/70 text-sm">
              {[
                { label: 'Home', to: '/' },
                { label: 'About Dr Khan', to: '/about' },
                { label: 'Services', to: '/services' },
                { label: 'Patient Information', to: '/patient-info' },
                { label: 'Refer a Patient', to: '/refer' },
                { label: 'Contact', to: '/contact' },
                { label: 'Register as Patient', to: '/register' },
                { label: 'Book Appointment', to: '/book' },
                { label: 'Portal Login', to: '/login' },
                { label: 'Privacy Policy', to: '/privacy-policy' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="hover:text-gold transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 — Contact */}
          <div>
            <h3
              className="font-heading text-lg mb-4"
              style={{ fontFamily: 'var(--font-heading)', color: 'var(--color-gold)' }}
            >
              Consulting Hours
            </h3>
            <ul className="space-y-1 text-white/70 text-sm mb-4">
              <li className="flex justify-between gap-4">
                <span>Monday – Thursday</span>
                <span>08:00 – 17:00</span>
              </li>
              <li className="flex justify-between gap-4">
                <span>Friday</span>
                <span>08:00 – 13:00</span>
              </li>
            </ul>
            <p className="text-white/60 text-sm">
              After hours:{' '}
              <a href={`tel:${AFTER_HOURS}`} className="hover:text-gold transition-colors" style={{ color: 'var(--color-gold)' }}>
                {AFTER_HOURS_DISPLAY}
              </a>
            </p>
            <p className="text-white/50 text-xs mt-3">
              Hospitals: JKD at Melomed Gatesville &amp; Melomed Mitchell's Plain
            </p>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-white/40 text-xs text-center mb-2">
            © 2026 IKhanGynae · HPCSA No. MP0851140 · This website is subject to POPIA —{' '}
            <Link to="/privacy-policy" className="underline hover:text-white/70 transition-colors">Privacy Policy</Link>
          </p>
          <p className="text-white/30 text-xs text-center max-w-3xl mx-auto">
            The information on this website is intended for general informational purposes only and does not constitute medical advice. Every patient's circumstances are different. Please consult Dr Khan or your healthcare provider for advice specific to your condition.
          </p>
        </div>
      </div>
    </footer>
  );
}
